import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-license-already-ordered-page",
  templateUrl: "./LicenseAlreadyOrderedPage.html",
})
export class LicenseAlreadyOrderedPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

  public get organization() {
    return this.appController.organization;
  }

}
